import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import StopPaymentPage, { getDefaultPageUI } from "components/pages/StopPaymentPage";

export default function CaptureStopPaymentAccountDD(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "accountDropdown", "isActive" ], true)
        .submit();

    return <StopPaymentPage ui={ ui } />
}